<template>
  <carousel
    ref="carousel"
    v-if="images.length > 1"
    class="relative image-carousel"
    :number-of-slides="images.length"
    :per-page-custom="[[320, 1], [848, 1]]">

    <template v-slot:default="{carousel}">
      <v-slide v-for="(item, imageIndex) in images" :key="imageIndex">
        <template
          v-if="imageIndex >= carousel.currentPage - 1 && imageIndex <= carousel.currentPage + 1"
        >
          <img :src="item" class="w-full h-full"/>
        </template>
      </v-slide>
    </template>

    <template v-slot:navigation="{ carousel }">
      <div class="image-carousel__actions px-4 flex items-center justify-between">
        <button
          type="button"
          @click="carousel.goToPrevPage"
          :disabled="!carousel.canAdvanceBackward"
        >
          <svg width="24" height="24" class="mx-auto">
            <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
          </svg>
        </button>

        <button
          type="button"
          @click="carousel.goToNextPage"
          :disabled="!carousel.canAdvanceForward"
        >
          <svg width="24" height="24" class="mx-auto">
            <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
          </svg>
        </button>
      </div>

      <div class="image-carousel__indicator flex items-center justify-center">
        <div v-for="(image, imageIndex) in images"
             :key="imageIndex"
             :class="{ 'active': carousel.currentPage === imageIndex }"
             @click="carousel.goToPage(imageIndex)">
        </div>
      </div>
    </template>
  </carousel>
  <div v-else class="w-full h-full">
    <img :src="images[0]" class="w-full h-full cover-image rounded-tl sm:rounded"/>
  </div>
</template>

<script>
import {Slide} from 'vue-carousel'

import Carousel from '../../components/core/Carousel'

export default {
  name: 'ImageCarouse',
  props: ['images','showIndicator'],
  components: {
    'v-slide': Slide,
    Carousel
  }
}
</script>

<style lang="scss" scoped>
.image-carousel {
  &__actions {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);

    button {
      border-radius: 50px;
      width: 40px;
      height: 40px;
      background-color: #ffffff91;

      &:disabled {
        pointer-events: none;
        opacity: 0.2;
      }
    }
  }

  &__indicator {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;

    div {
      width: 10px;
      height: 10px;
      background: hsla(0,0%,100%,.45);
      margin: 0 3px;
      border-radius: 50%;
      cursor: pointer;

      &.active {
        background-color: #fff;
        width: 14px;
        height: 14px;
        margin-top: -3px;
      }
    }
  }
}
</style>
